import { TypeAheadFilter } from './TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';
import { PolicyStatus, PolicyStatusText } from '@models/policy';

export interface PolicyStatusFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

// Exported so the filter config can reuse the exact same options — the table's
// URL-restore logic uses them to map raw status strings back to option objects.
export const policyStatusFilterOptions = Object.values(PolicyStatus).map((status) => ({
  key: status,
  label: PolicyStatusText[status],
  value: status,
}));

export const PolicyStatusFilter = (componentProps: PolicyStatusFilterProps) => {
  const { value, disabled } = componentProps;

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled}
      label={componentProps.label}
      options={policyStatusFilterOptions}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={1}
      onChange={componentProps.onChange}
      horizontalLabel={true}
    />
  );
};
